// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.011 15.937a.93.93 0 0 1-.669-.273l-7.496-7.5c-.323-.332-.41-.914 0-1.324s.977-.343 1.325 0 6.84 6.836 6.84 6.836l6.836-6.841c.32-.32.927-.392 1.32.001.337.338.416.913 0 1.33l-7.5 7.498a.9.9 0 0 1-.656.273"
  }));
};
